import React from 'react';
import { StoryCard } from './StoryCard';
interface Story {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  timestamp: string;
  imageUrl?: string;
}
interface SectionPreviewProps {
  title: string;
  stories: Story[];
}
export function SectionPreview({
  title,
  stories
}: SectionPreviewProps) {
  return <section className="mb-12" data-id="element-50">
      <div className="flex items-center mb-6 border-b-2 border-ink pb-2" data-id="element-51">
        <h2 className="text-xl font-bold uppercase tracking-widest flex-1" data-id="element-52">
          {title}
        </h2>
        <span className="text-xs font-serif italic text-gray-500" data-id="element-53">
          See all {title.toLowerCase()}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-54">
        {stories.map((story, index) => <div key={story.id} className={index > 0 ? 'hidden md:block' : ''} data-id="element-55">
            <StoryCard title={story.title} excerpt={story.excerpt} author={story.author} category={title} timestamp={story.timestamp} imageUrl={story.imageUrl} data-id="element-56" />
          </div>)}
      </div>

      {/* Mobile list view for hidden items */}
      <div className="md:hidden mt-4 space-y-4" data-id="element-57">
        {stories.slice(1).map(story => <StoryCard key={`mobile-${story.id}`} title={story.title} excerpt={story.excerpt} author={story.author} category={title} timestamp={story.timestamp} compact={true} data-id="element-58" />)}
      </div>
    </section>;
}